import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'

const CookiePolicyModal = ({ onClose }: { onClose: () => void }) => {
  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              All<span>Fans</span>
            </h2>
            <div className="pf-page__descr">Cookie Policy</div>
          <div className="pf-main-list">
            <p>Last modified: 2025/06/21</p>
            <p>Cookies are small files of letters and numbers stored on your browser or device that enable the cookie owner to 
              recognize the device when it visits websites or uses online services. The website you visit may set cookies 
              directly, known as first-party cookies, or may trigger cookies set by other domain names, known as third-party 
              cookies. While we may automatically use some cookies that are strictly necessary to provide the services you 
              request or enable communications, we request your consent for all of our other cookie uses.</p>
            
            <h5>Types of Cookies We Use</h5>
            <ul>
              <li>
                <p><strong>Strictly necessary cookies.</strong> Our website requires the use of these cookies to properly operate or provide 
                  necessary functions relating to the services you request. They include, for example, cookies enabling you to 
                  securely log into our website, follow a Creator, or purchase Content. These are session cookies 
                  that generally last 2 years or until logging out of the application.</p>
              </li> 
              <li>
                <p><strong>Analytical/performance cookies.</strong> These cookies allow us and our third-party service providers to recognize and 
                  count the number of visitors and to see how visitors move around our website when they are using it. This helps us improve 
                  how our website works by, for example, ensuring that Users can easily find what they need on our website. These 
                  cookies generate aggregate statistics that are not associated with an individualized profile and are 
                  session cookies that generally last 2 years.</p>
              </li> 
              <li>
                <p><strong>Functionality cookies.</strong> These cookies enable helpful but non-essential website functions 
                  that improve your website experience. By recognizing you when you return to our website, they may, 
                  for example, allow us to personalize our content for you, greet you by name, or remember your 
                  preferences (for example, your choice of language or region). These cookies may enable visitor identification over 
                  time, but not across different websites. These are session cookies that generally last 2 years.</p>
              </li> 
              <li>
                <p><strong>Advertising, tracking, or targeting cookies.</strong> These cookies enable different advertising-related 
                  functions. They may allow us to record information about your visit to our website, such as pages visited, 
                  links followed, and videos viewed so we can make our website and the advertising displayed on it more relevant 
                  to your interests. These cookies may enable visitor identification over time, but not across different 
                  websites. These are session cookies that generally last 2 years.</p>
              </li> 
              <li>
                <p><strong>Third-party cookies.</strong> Our website may contain helpful but nonessential features or plug-ins enabling 
                  third-party services that use cookies, including social network connectors, maps, advertising networks, or 
                  web traffic analysis services. These cookies may enable visitor identification across websites and over time. 
                  We do not control the third party’s use of those cookies, their duration, or their ability to share information 
                  with other third parties. Please review each party’s cookie disclosure before consenting to this use category.</p>
              </li>  
            </ul>
          <p>
            Our <a href='/privacypolicy' className='terms-link'>Privacy Policy</a> describes our practices for any personal data that our first-party cookies collect, store, or use, including 
            our legal basis for processing personal data.
          </p>  
          <p>
            Except for strictly necessary cookies, all first-party cookies set by this site will expire no later than 2 years 
            after your last website visit. Third-party cookie expiration periods are set by their respective owners.
          </p>
          <p>
            Please see our <Link to="/cookietable" className="terms-link">Cookie Table</Link> for a list of the individual first-party and third-party cookies potentially used on this site 
            and their specific purposes.
          </p>
          <h5>Cross-Border Data Transfers</h5>
          <p>
            The cookies we use may process, store, or transfer personal data in and to a country outside your own, with privacy 
            laws that provide different, possibly lower, protections. You consent to this transfer, storing, or processing when you consent to our cookie use. We are based in the United States of America. Please review each third-party cookie provider’s policy to learn more about its location.
          </p>
          <h5>Your Cookie Choices</h5>
          <p>Please visit our <Link to="/cookies" className="terms-link">Consent Manager Tool</Link> to make or manage your cookie use preferences.</p>
          <p>You may withdraw your consent for our cookie uses that are not strictly necessary at any time by reengaging the <Link to="/cookies" className="terms-link">Consent Manager Tool</Link>.</p>
          <p>Most web browsers allow you to directly block all cookies, or just third-party cookies, through your browser settings. Using your browser 
            settings to block all cookies, including strictly necessary ones, may interfere with proper site operation.</p>

          <h5>Changes to Our Cookie Uses</h5>
          <p>
            We will post any changes to the way we use cookies on this page. If the changes materially alter how we use cookies, we will post 
            a notice on our website and request your consent for the materially different use. Please check back frequently 
            to see any updates or changes to our cookie use notice.
          </p>
          <h5>Contact Information</h5>
          <p>
            Please submit any questions, comments, or requests regarding this cookie use notice to privacy@allfans.com.
          </p>
          </div>
          </div>
        </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-default"
                style={{
                  width: '100%',
                  maxWidth: '220px'
                }}
              >
                Close
              </button>
            </div>
          </div>
      </div>
    </div>, document.body
  )
}

export default CookiePolicyModal
